/* This is the EMIS Pre external toys components */

<template>
  <v-container>
    <div>
			<span v-html="title"></span>
		</div>
		<div>
      <table style="height: 61px;" border="1px;" width="358" cellspacing="0px;">
        <tbody>
          <tr>
            <td style="width: 100px; height: 25px; text-align: center; vertical-align: middle;">ប្រភេទ</td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">សូមគូសរង្វង់</td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">ស្ថានភាពទូទៅ</td>
          </tr>
          <tr v-for="(value, row) in e4.length" :key="row" style="height: 25px;">
            <td style="width: 100px; height: 25px; text-align: left; vertical-align: middle;">
              {{e4[row]}}
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              <v-select v-model="data[row].dt[0]" :items="yesNo2" item-text="text" item-value="value" 
                outline
                hide-details
                @keypress.native="onSelect1($event, row, 0)"
                class="d-inline" style="width:100px;height: 25px;font-size: 9px;">
              </v-select>
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              <v-select v-model="data[row].dt[1]" :items="yesNo6" item-text="text" item-value="value" 
                outline
                hide-details
                @keypress.native="onSelect2($event, row, 1)"
                class="d-inline" style="width:100px;height: 25px;font-size: 9px;">
              </v-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { yesNo2 } from '@/utils/ascf/commonConfig.js'
import { yesNo6, e4 } from '@/utils/ascf/preConfig.js'
export default {
  props: ["data", "title"],
  data() {
    return {
      e4: e4,
      yesNo2: yesNo2,
      yesNo6: yesNo6
    }
  },
  methods: {
    onSelect1: function (event, row, col) {
      var charCode = event.keyCode
      if (charCode >= 49 && charCode <= 50) {
        this.data[row].dt[col] = charCode - 48
        this.$forceUpdate()
      }
    },
    onSelect2: function (event, row, col) {
      var charCode = event.keyCode
      if (charCode >= 49 && charCode <= 50) {
        this.data[row].dt[col] = charCode - 48
        this.$forceUpdate()
      }
    }
  }
}
</script>
<style scoped>
	.input-group--select >>> .input-group__selections__comma {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 12px;
    padding: 1px 1px 1px 0;
  }
</style>